import { Mixins, Component } from 'vue-property-decorator';
import MallInfo from '@/components/term/mixins/MallInfo';
import { APIResponse } from '@/types/manage';
import { Terms, TermsType } from 'supporter';
import { namespace } from 'vuex-class';
import { toI18n } from '@/utils/commonUtils';
import { ncpPopup } from '@/utils/ncp';
import { getToday } from '@/utils/dateUtils';
import cloneDeep from 'lodash.clonedeep';

const termsModule = namespace('terms');

interface TermsTypeDataItem {
  name: string;
  termsType: TermsType | TermsType[]; // FIXME : 레거시 코드에서 이렇게 다루고 있다. TermsType[]로 통일시킬 수 있게 변경하는 게 좋을 것 같다.
  termsTypeUsingEnforcementDateTime: TermsType[];
  wantToSaveOnlyDiff?: boolean;
}

let termsDataForDiff: { [propName: string]: Terms } = {};

@Component
export default class Common extends Mixins(MallInfo) {
  @termsModule.Mutation('SET_NCPLAYERISEXIST') public setPopIsExist!: (isExist: boolean) => void;
  @termsModule.Mutation('SET_NCPLAYERISSHOW') public setPopIsShow!: (isExist: boolean) => void;
  @termsModule.Mutation('SET_POPINFO') public setPopInfo!: (popInfo: {}) => void;

  public responseData: Terms[] = [];
  public pageAllData: { [propName: string]: Terms } = {};
  public allEditorData: { [propName: string]: string } = {};
  public termDefaultData: any = {
    no: 0,
    mallNo: -1,
    termsType: '',
    contents: '',
    used: true,
    enforcementDateTime: null,
  };

  public left: number = 0;
  public setLeft(): number {
    if (!this.currentMallNo) return (this.left = 0);
    const pos = this.mallNos.indexOf(this.currentMallNo) + 1;
    const containerWidth = $('.mall_list_wrap .mall_list').width();
    const to = pos - Math.floor(containerWidth / 112);
    if (to >= 0) {
      return (this.left = -to * 112 - 112 + (containerWidth % 112));
    } else {
      return (this.left = 0);
    }
  }

  public get currentTabname(): string {
    let tabName = this.$route.name;
    if (tabName) {
      tabName = tabName.toLocaleLowerCase();
    } else {
      tabName = '';
    }
    return tabName;
  }

  public get currentTermsType(): string | string[] {
    return this.getTermTypeByTabName(this.currentTabname);
  }

  public get termsTypeUsingEnforcementDateTimeInCurrentTab(): string[] {
    return this.termsTypeData.find(termsTypeObj => termsTypeObj.name === this.currentTabname)
      .termsTypeUsingEnforcementDateTime;
  }

  public termsTypeData: TermsTypeDataItem[] = [
    { name: 'introduction', termsType: 'MALL_INTRODUCTION', termsTypeUsingEnforcementDateTime: [] },
    {
      name: 'access',
      termsType: ['USE', 'REGULAR_PAYMENT_USE', 'AUTO_APPROVAL_USE'],
      termsTypeUsingEnforcementDateTime: ['USE', 'REGULAR_PAYMENT_USE', 'AUTO_APPROVAL_USE'],
      wantToSaveOnlyDiff: true,
    },
    { name: 'e-commerce', termsType: 'E_COMMERCE', termsTypeUsingEnforcementDateTime: ['E_COMMERCE'] },
    { name: 'personal-info', termsType: 'PI_PROCESS', termsTypeUsingEnforcementDateTime: ['PI_PROCESS'] },
    {
      name: 'collection',
      termsType: [
        'PI_COLLECTION_AND_USE_REQUIRED',
        'PI_COLLECTION_AND_USE_OPTIONAL',
        'PI_PROCESS_CONSIGNMENT',
        'PI_THIRD_PARTY_PROVISION',
        'PI_SELLER_PROVISION',
        'PI_COLLECTION_AND_USE_ON_ORDER',
        'ORDER_INFO_AGREE',
        'CLEARANCE_INFO_COLLECTION_AND_USE',
        'TRANSFER_AGREE',
        'PI_COLLECTION_AND_USE_FOR_GUEST_ON_ARTICLE',
        'PI_RESTOCK_NOTICE',
        'PI_LIQUOR_PURCHASE_PROVISION',
        'PI_COLLECTION_AND_USE_FOR_GUEST_ON_ARTICLE',
      ],
      termsTypeUsingEnforcementDateTime: [],
    },
    {
      name: 'withdrawal',
      termsType: ['WITHDRAWAL_GUIDE', 'ACCESS_GUIDE'],
      termsTypeUsingEnforcementDateTime: [],
      wantToSaveOnlyDiff: false,
    },
  ];

  public calendarOption(name: string) {
    return {
      fromRanges: getToday(),
      topContainer: true,
      placeholder: 'TERMS_PERSONALINFO_PLACEHOLDER',
      name: name,
    };
  }

  public initPop(popInfo: any): void {
    this.setPopInfo(popInfo);
    this.setPopIsShow(true);
  }

  public getTermTypeByTabName(tabName: string): string | string[] {
    return (
      this.termsTypeData.find((termsTypeObj: { name: string }): {} => termsTypeObj.name === tabName) || {
        name: '',
        termsType: '',
      }
    ).termsType;
  }

  public getTerms(): Promise<APIResponse> {
    const termsType = this.getTermTypeByTabName(this.currentTabname);
    const params: any = {
      termsType: termsType.toString(),
      mallNo: this.currentMallNo,
    };
    return new Promise((resolve: any, reject: any): void => {
      this.$api
        .getTerms({ params })
        .then((response: any): void => {
          resolve(response);
        })
        .catch((error: any): void => {
          reject(error);
        });
    });
  }

  public afterGetTerms(): void {
    this.initPageAllData();
    this.getTerms().then(({ data = [] }: APIResponse): void => {
      this.responseData = data;
      this.renderData();
    });

    this.setLeft();
  }

  public initPageAllData(): void {
    const mallNo = this.currentMallNo;
    if (Array.isArray(this.currentTermsType)) {
      const tempObj = {};
      this.currentTermsType.forEach((termsType: string): void => {
        Object.assign(tempObj, { [termsType]: { ...this.termDefaultData, termsType, mallNo } });
      });
      
      this.pageAllData = Object.assign({}, tempObj);
    } else {
      this.pageAllData = Object.assign(
        {},
        { [this.currentTermsType]: { ...this.termDefaultData, termsType: this.currentTermsType, mallNo } },
      );
    }
  }

  public renderData(): void {
    const targetTermsType = Array.isArray(this.currentTermsType) ? [...this.currentTermsType] : [this.currentTermsType];
    const data = {};

    targetTermsType.reverse().forEach((termsType: string): void => {
      const arrTemp = this.responseData.filter((terms: Terms) => terms.termsType === termsType);

      if (arrTemp.length > 0) {
        data[termsType] = {
          ...arrTemp[arrTemp.length - 1],
          mallNo: this.currentMallNo,
        };
      }
    });

    Object.assign(this.pageAllData, data);
    if (this.termsTypeData.find(data => data.name === this.currentTabname).wantToSaveOnlyDiff) {
      termsDataForDiff = cloneDeep(this.pageAllData);
    }

    this.$nextTick(() => {
      window.scrollTo(0, 0);
    });
  }

  public iniAllEditorData(): void {
    if (Array.isArray(this.currentTermsType)) {
      const tempObj = {};
      this.currentTermsType.forEach((termsType: string): void => {
        Object.assign(tempObj, { [termsType]: '' });
      });
      this.allEditorData = Object.assign({}, tempObj);
    } else {
      this.allEditorData = Object.assign({}, { [this.currentTermsType]: '' });
    }
  }

  public editorOnChange({ html, editorId }: { html: string; editorId: string }): void {
    Object.assign(this.allEditorData, { [editorId]: html });
  }

  public isShow(val: any): boolean {
    if (val === true || val === 'true') {
      return true;
    } else {
      return false;
    }
  }

  public getTermsStandard(termsType: TermsType): void {
    const params = {
      termsType,
    };
    this.$api.getTermsStandard({ params }).then((response: any): void => {
      const { termsType, contents }: { termsType: string; contents: string } = response.data;
      this.pageAllData[termsType].contents = contents;
    });
  }

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }

  public entries(obj: { [propName: string]: any }): any[] {
    const ownProps = Object.keys(obj);
    let i = ownProps.length;
    const resArray = new Array(i);
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }
    return resArray;
  }

  public editorUse(editorId: string): void {
    this.pageAllData[editorId].contents = '<p></p>';
    this.$nextTick((): void => {
      this.pageAllData[editorId].contents = '';
    });
  }

  public save(): void {
    const isThereTermsTypeUsingEnforcementDateTime = this.termsTypeUsingEnforcementDateTimeInCurrentTab.length;
    const currentTermsTypeData = this.termsTypeData.find(data => data.name === this.currentTabname);

    const removeTimeFromEnforcementDateTime = (enforcementDateTime?: string): string | null => {
      if (!enforcementDateTime) return null;
      return enforcementDateTime.split(' ')[0];
    };

    // FIXME : termsType의 타입이 string | string[] 이어서 코드가 더러워지고 있다..
    const currentTermsTypeList =
      typeof this.currentTermsType === 'string' ? [this.currentTermsType] : [...this.currentTermsType];

    let termsTypeToSave = currentTermsTypeList;

    if (currentTermsTypeData.wantToSaveOnlyDiff) {
      // wantToSaveOnlyDiff === true 인 경우, 변경한 항목에 대해서만 저장함 (이용약관쪽 기획 요청)
      // enforcementDateTime은 pageAllData에 바로 동기화 되지만, 에디터 입력 내용은 allEditorData에 저장되어있다.
      const termsTypeWithDiffContents = currentTermsTypeList.filter(
        type => termsDataForDiff[type]?.contents !== this.allEditorData[type],
      );
      const termsTypeWithDiffEnforcementDateTime = currentTermsTypeList.filter(
        type =>
          removeTimeFromEnforcementDateTime(termsDataForDiff[type].enforcementDateTime) !==
          removeTimeFromEnforcementDateTime(this.pageAllData[type].enforcementDateTime),
      );

      termsTypeToSave = [...new Set([...termsTypeWithDiffContents, ...termsTypeWithDiffEnforcementDateTime])];
    }

    const allDataToSave = cloneDeep(this.pageAllData);
    for (const termsTypeAsKey in allDataToSave) {
      if (!termsTypeToSave.includes(termsTypeAsKey)) {
        delete allDataToSave[termsTypeAsKey];
      }
    }

    if (isThereTermsTypeUsingEnforcementDateTime) {
      const termsTypeUsingEnforcementDateTimeInAllDataToSave = termsTypeToSave.filter(type =>
        this.termsTypeUsingEnforcementDateTimeInCurrentTab.includes(type),
      );

      const isEnforcementDateTimeEmpty = termsTypeUsingEnforcementDateTimeInAllDataToSave.some(
        termsType => !Boolean(allDataToSave[termsType].enforcementDateTime),
      );

      const isEnforcementDateTimePast = termsTypeUsingEnforcementDateTimeInAllDataToSave.some(
        termsType => allDataToSave[termsType].enforcementDateTime < getToday(),
      );

      if (isEnforcementDateTimeEmpty) {
        alert(this.toI18n('TERMS_MIXINS_MSG1')); // 시행일을 선택해주세요.
        return;
      } else if (isEnforcementDateTimePast) {
        alert(this.toI18n('TERMS_MIXINS_MSG9')); // 지난 시행일은 저장할 수 없습니다.
        return;
      }
    }

    const requestData = [];
    for (let [key] of this.entries(allDataToSave)) {
      delete allDataToSave[key].no;
      const { fairLogoType, used, mallNo, termsType, enforcementDateTime } = allDataToSave[key];
      const requestDataItem = {
        fairLogoType,
        contents: this.allEditorData[key],
        used,
        mallNo,
        termsType,
      };
      if (Boolean(enforcementDateTime)) {
        // 시행일 데이터를 보낼 때는 'enforcementDate' 프로퍼티로 보내야하는 상황
        requestDataItem['enforcementDate'] = enforcementDateTime;
      }
      requestData.push(requestDataItem);
    }

    Promise.all(
      requestData.map(
        async (data: any): Promise<void> => {
          await this.$api.postTerms({ data });
        },
      ),
    ).then((): void => {
      alert(this.toI18n('TERMS_MIXINS_MSG2')); // 저장 되었습니다.
      window.location.reload();
    });
  }

  public openHistoryWin(type: string = this.currentTabname): void {
    // eslint-disable-next-line quotes
    const url = `/terms/popup/${type}?mallNo=${this.currentMallNo}`;
    ncpPopup(url, type, 970, 500);
  }

  public created(): void {
    this.setPopIsExist(true);
    this.iniAllEditorData();
    this.initPageAllData();
    this.afterGetTerms();
  }

  public mounted(): void {
    this.setLeft();
  }
}
